import React from "react";
import WorkspaceToolbar from "../preview/WorkspaceToolbar";
import PreviewGrid from "../preview/PreviewGrid";

function Workspace({
  finalUrl,
  selectedDevices,
  orientationByDevice,
  layoutMode,
  setLayoutMode,
  globalZoom,
  setGlobalZoom,
  sortMode,
  setSortMode,
  globalReloadToken,
  onReloadAll,
  onRotateAll,
  onClearWorkspace,
  onRotateDevice,
  onRemoveDevice,
}) {
  return (
    <main className="workspace" aria-label="Preview workspace">
      <WorkspaceToolbar
        layoutMode={layoutMode}
        setLayoutMode={setLayoutMode}
        globalZoom={globalZoom}
        setGlobalZoom={setGlobalZoom}
        sortMode={sortMode}
        setSortMode={setSortMode}
        onReloadAll={onReloadAll}
        onRotateAll={onRotateAll}
        onClearWorkspace={onClearWorkspace}
        deviceCount={selectedDevices.length}
      />

      <PreviewGrid
        finalUrl={finalUrl}
        devices={selectedDevices}
        orientationByDevice={orientationByDevice}
        globalZoom={globalZoom}
        globalReloadToken={globalReloadToken}
        layoutMode={layoutMode}
        sortMode={sortMode}
        onRotate={onRotateDevice}
        onRemove={onRemoveDevice}
      />
    </main>
  );
}

export default Workspace;
